<template>
    <div class="page d-flex">
        <MenuComponent />
        <DashboardComponent  />
    </div>
</template>

<script>
import MenuComponent from '@/components/user/layout/MenuComponent.vue';
import DashboardComponent from '@/components/user/viewComponent/dashboard/DashboardComponent.vue';

export default{
	name: 'DashboardView',
    components:{
        MenuComponent,
        DashboardComponent,
    },
}
</script>

<style >
</style>